export default __webpack_public_path__ + "static/media/send_mail.6556f645.svg";